import { Injectable } from "@angular/core";
import {
  CanLoad,
  Route,
  UrlSegment,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../service/auth.service";

@Injectable({
  providedIn: "root",
})
export class UserRoleGuard implements CanLoad {
  constructor(
    private router: Router,
    private authenticationService: AuthService
  ) {}
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const user = this.authenticationService.userValue;
    if (user.role == "admin") {
      return true;
    } else {
      alert("You are not authorised to visit this page");
      this.router.navigate(["Home"]);
      return false;
    }
  }
}
